import React from 'react';

import PropTypes from 'prop-types';

import ERROR_FILE_ICON from '@/assets/icons/si-glyph-document-error.svg';

import './AdvSetup.css';

function AdvSetup({label, onClick, id, advSetupNotFound}) {
  return (
    <div
      className="parentAdvSetup"
      onClick={onClick}
      id={id}
    >
      <div className="row advSetupIcon center">
        {!advSetupNotFound && <span className="glyphicon glyphicon-file icon" />}
        {advSetupNotFound && (
          <img
            src={ERROR_FILE_ICON}
            height={50}
            width={50}
            className="glyphicon glyphicon-file icon"
            alt="icon"
          />
        )}
      </div>
      <div className="row advSetupLabel">
        <span>{label}</span>
      </div>
    </div>
  );
}

AdvSetup.propTypes = {
  advSetupNotFound: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  id: PropTypes.string,
};

AdvSetup.defaultProps = {
  advSetupNotFound: false,
  label: '',
  id: '',
  onClick: () => {},
};

export default AdvSetup;
